import { registerModulePaths } from '@platform/core/lib/modulePaths';
import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

const groups: IModuleGroupManifest[] = [];
const modules = new Map<string, IModuleManifest>();

/** Реєстрація пакетів груп (і адрес їхніх модулів — modulePaths, ADR-028). Викликає оболонка застосунку з реєстру `@modules`; платформа сама пакети не імпортує (межі шарів). */
export function registerModuleGroups(list: IModuleGroupManifest[]): void {
  groups.splice(0, groups.length, ...[...list].sort((a, b) => a.sort - b.sort));
  modules.clear();
  for (const group of groups) for (const module of group.modules) modules.set(module.key, module);
  registerModulePaths(groups);
}

export function findModule(key: string): IModuleManifest | undefined {
  return modules.get(key);
}

export function registeredModuleGroups(): readonly IModuleGroupManifest[] {
  return groups;
}
